module.exports = __webpack_public_path__ + "static/logotypes-slider-f63cf19e4448d54b1a502d0c4339712d.jpg";